// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as ListLabels from "../../../../../../../node_modules/rescript/lib/es6/listLabels.js";
import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function decodeWeeklySummary(json) {
  return {
          totalEarnings: Json_decode.field("total_earnings", Json_decode.$$float, json),
          totalTrips: Json_decode.field("num_trips_completed", Json_decode.$$int, json),
          startDate: new Date(Json_decode.field("start_date", Json_decode.string, json)),
          endDate: new Date(Json_decode.field("end_date", Json_decode.string, json))
        };
}

function execute(data, msisdn) {
  return {
          earningSummaries: Json_decode.field("weekly_earning_summaries", (function (param) {
                  return Json_decode.list(decodeWeeklySummary, param);
                }), data),
          msisdn: msisdn
        };
}

var WeeklyEarningSummary = {
  decodeWeeklySummary: decodeWeeklySummary,
  execute: execute
};

function decodeOrderDetail(json) {
  return {
          orderId: Json_decode.field("order_id", Json_decode.string, json),
          pickupTime: Json_decode.field("pickup_time", Json_decode.$$int, json),
          pickupLocality: Json_decode.field("pickup_locality", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          dropLocality: Json_decode.field("drop_locality", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function decodeWorkUnit(json) {
  var workUnitType = Json_decode.field("type", Json_decode.string, json);
  var defaultTitle = Json_decode.field("default_title", Json_decode.string, json);
  switch (workUnitType) {
    case "LOGIN" :
        return {
                TAG: /* Login */1,
                _0: defaultTitle
              };
    case "MBG" :
        return {
                TAG: /* Mbg */2,
                _0: defaultTitle
              };
    case "ORDER" :
        var orderDetail = Json_decode.field("abridged_order_details", decodeOrderDetail, json);
        return {
                TAG: /* Order */0,
                _0: defaultTitle,
                _1: orderDetail
              };
    default:
      return ErrorUtils$Catalyst.raiseError("DriverEarningStateMapper.re", "Invalid workUnitType ", workUnitType);
  }
}

function decodeDailyDetail(json) {
  return {
          workUnit: Json_decode.field("work_unit", decodeWorkUnit, json),
          totalEarnings: Json_decode.field("total_earnings", Json_decode.$$float, json),
          totalCashSettlement: Json_decode.field("total_cash_settlement", Json_decode.$$float, json),
          totalWalletSettlement: Json_decode.field("total_wallet_settlement", Json_decode.$$float, json)
        };
}

function getDailyEarningsDetail(earningReports, date) {
  return List.map((function (dailyWorkUnitEarning) {
                return {
                        workUnit: dailyWorkUnitEarning.workUnit,
                        totalEarnings: dailyWorkUnitEarning.totalEarnings,
                        totalCashSettlement: dailyWorkUnitEarning.totalCashSettlement,
                        totalWalletSettlement: dailyWorkUnitEarning.totalWalletSettlement,
                        date: date
                      };
              }), earningReports);
}

function decodeWorkUnitEarningDetail(json) {
  var date = new Date(Json_decode.field("date", Json_decode.string, json));
  var earningReports = Json_decode.field("work_unit_earning_reports", (function (param) {
          return Json_decode.list(decodeDailyDetail, param);
        }), json);
  return getDailyEarningsDetail(earningReports, date);
}

function decodeWeeklyDetail(json) {
  return ListLabels.flatten(Json_decode.field("daily_earning_reports", (function (param) {
                    return Json_decode.list(decodeWorkUnitEarningDetail, param);
                  }), json));
}

function execute$1(data, msisdn) {
  var list = Json_decode.field("weekly_earning_reports", (function (param) {
          return Json_decode.list(decodeWeeklyDetail, param);
        }), data);
  return {
          weeklyEarnings: List.nth(list, 0),
          msisdn: msisdn
        };
}

var WeeklyEarningDetail = {
  decodeOrderDetail: decodeOrderDetail,
  decodeWorkUnit: decodeWorkUnit,
  decodeDailyDetail: decodeDailyDetail,
  getDailyEarningsDetail: getDailyEarningsDetail,
  decodeWorkUnitEarningDetail: decodeWorkUnitEarningDetail,
  decodeWeeklyDetail: decodeWeeklyDetail,
  execute: execute$1
};

export {
  WeeklyEarningSummary ,
  WeeklyEarningDetail ,
  
}
/* No side effect */
